<template>
  <div class="general-wrapper">
      <Header />

      <PageContainer>
          <div class="iqos-grid" v-if="ready_to_render">
              <div class="iqos-column">
                  <ChainGeneralPanel />
                  <CafeLogosPanel is_chain/>
              </div>
              <div class="iqos-column">
                  <ChainSettingsPanel :chain="chain"/>
                  <OnlineMenuLinkCard is_chain/>
              </div>
          </div>
      </PageContainer>
  </div>
</template>

<script>
import OnlineMenuLinkCard from "@/components/general/OnlineMenuLinkCard.vue"
import CafeLogosPanel from "@/components/general/CafeLogosPanel.vue"
import ChainGeneralPanel from "@/components/chain/ChainGeneralPanel.vue"
import ChainSettingsPanel from "@/components/chain/ChainSettingsPanel.vue"


export default {
    data() {
        return {
            ready_to_render: false
        }
    },
    mounted() {
        if (!this.chain) {
            this.$router.push('/');
        } else {
            this.$store.commit('selectChain', this.chain);
            this.ready_to_render = true;
        }
    },
    computed: {
        cafe() {
            return this.$store.state.cafe;
        },
        chain() {
            return this.$store.state.chains.find(it => it._id == this.$route.params.chain_id);
        }
    },
    components: {
        OnlineMenuLinkCard,
        ChainGeneralPanel,
        ChainSettingsPanel,
        CafeLogosPanel
    }
}
</script>

<style>

</style>
